import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {greyishBlue500} from "assets/jss/main";

VariationSku.propTypes = {
    sku: PropTypes.string
};

function VariationSku({sku}) {
    return (
        <span
            style={{
                flexShrink: 0,
                color: greyishBlue500,
            }}
        >
            <FormattedMessage
                id='product.show.modificationLog.variationSku'
                values={{sku: sku}}
            />
        </span>
    );
}

export default VariationSku;
